export default __webpack_public_path__ + "static/media/home.bdef29c1.svg";